import React from 'react';
import { CheckIcon, GiftIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { SectionHeading } from './SectionHeading';
import { BONUS_VALUE, bonuses, includedTomos, PRODUCT } from '../data/content';
export function ValueStackSection() {
  return <section aria-labelledby="recibes" className="border-y-2 border-volt/25 bg-carbon" data-id="element-249" data-mp="1me4h41l2zp3t">
      <div className="mx-auto max-w-page px-3 py-8 sm:px-6 sm:py-10" data-id="element-250" data-mp="tnmibcre49w7">
        <Reveal data-id="element-251" data-mp="tnw7iy4m2d0u">
          <SectionHeading id="recibes" title="¿Qué recibes hoy?" data-id="element-252" data-mp="tph22nqxdvyp" />
        </Reveal>

        <div className="mx-auto mt-5 grid max-w-4xl gap-3 md:grid-cols-2" data-id="element-253" data-mp="oqno6u7q82y0">
          <Reveal className="flex h-full flex-col rounded-xl border border-white/10 bg-night p-4" data-id="element-254" data-mp="12p3tcgpxxle1">
            <h3 className="text-center font-display text-[0.95rem] uppercase leading-tight text-volt sm:text-base" data-id="element-255" data-mp="ylxnha6qpw83">
              ⚡ {PRODUCT}
            </h3>
            <ul className="mt-3 space-y-2" data-id="element-256" data-mp="2a25txmpalrp1">
              {includedTomos.map(item => <li key={item} className="flex items-start gap-2 text-[0.8rem] font-semibold leading-snug text-white sm:text-sm" data-id="element-257" data-mp="1nd8lbgsoprqi">
                  <CheckIcon size={15} className="mt-0.5 flex-shrink-0 text-success" strokeWidth={3} data-id="element-258" data-mp="1sdwbk093a4jo" />
                  {item}
                </li>)}
            </ul>
          </Reveal>

          <Reveal delay={0.05} className="flex h-full flex-col rounded-xl border-2 border-volt bg-volt/10 p-4" data-id="element-259" data-mp="14obp37dq8p5n">
            <h3 className="text-center font-display text-[0.95rem] uppercase leading-tight text-volt sm:text-base" data-id="element-260" data-mp="1dmnex76rrix1">
              Más: 5 bonos incluidos
            </h3>
            <ul className="mt-3 space-y-2" data-id="element-261" data-mp="1ifqblo6uf8hg">
              {bonuses.map(bono => <li key={bono.shortTitle} className="flex items-start justify-between gap-2 text-[0.8rem] leading-snug text-white sm:text-sm" data-id="element-262" data-mp="kwf4y2me04tj">
                  <span className="flex items-start gap-2 font-semibold" data-id="element-263" data-mp="1t6nm2fr13rs3">
                    <GiftIcon size={15} className="mt-0.5 flex-shrink-0 text-volt" data-id="element-264" data-mp="1o8m7o84jsgmy" />
                    {bono.shortTitle}
                  </span>
                  <span className="flex-shrink-0 text-steel line-through" data-id="element-265" data-mp="1xzqkp2anxrf5">
                    {bono.value}
                  </span>
                </li>)}
            </ul>
            <div className="mt-auto pt-3 text-center" data-id="element-266" data-mp="15bupy34nm9l0">
              <p className="text-[0.72rem] font-extrabold uppercase tracking-wide text-white sm:text-xs" data-id="element-267" data-mp="1ja2izzykkqqw">
                💰 Solo los 5 bonos tienen un valor de {BONUS_VALUE}
              </p>
              <p className="mt-1 font-display text-lg uppercase leading-tight text-volt sm:text-xl" data-id="element-268" data-mp="2uphd8vze94ib">
                Pero hoy no pagas {BONUS_VALUE} por los bonos. Los 5 están
                incluidos gratis con tu compra.
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>;
}